import { render, staticRenderFns } from "./PublisherBottomNav.vue?vue&type=template&id=7e8041e8&"
import script from "./PublisherBottomNav.vue?vue&type=script&lang=js&"
export * from "./PublisherBottomNav.vue?vue&type=script&lang=js&"
import style0 from "./PublisherBottomNav.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports